import { useContext, useEffect } from 'react'
import { useRouter } from 'next/router'
import { LanguageContext } from '../components/LanguageContext/LanguageContext'
import { UserContext } from '../components/UserContext/UserContext'
import { APPLICATION_ID } from '../constants/applicationId'
import { useEnv } from '../utils/useEnv'
import { getAppId } from '../utils/appId'
import { connectMarketingEntryPoint } from '../utils/marketingEntryPoint'

export const useMarketingEntryPoint = () => {
  const { query } = useRouter()
  const { language } = useContext(LanguageContext)
  const { user } = useContext(UserContext)
  const env = useEnv()

  useEffect(() => {
    const appId = getAppId(query) || APPLICATION_ID

    connectMarketingEntryPoint({
      appId,
      language,
      env,
      user,
    })
  }, [query, language, user, env])
}
